import { faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { SERVER_URL } from '../../../Config';
import axios from 'axios';
import toast from "react-hot-toast";

export default function Userdata() {

  const [currentPage, setCurrentPage] = useState(1);
  const [entitiesPerPage, setEntitiesPerPage] = useState(7);
  const [searchTerm, setSearchTerm] = useState("");
  const [usersList, setUsersList] = useState([]);

  const filteredEntries = usersList?.filter(
    (entry) =>
      entry.user_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      entry.app_id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredEntries.length / entitiesPerPage);
  const indexOfLastEntity = currentPage * entitiesPerPage;
  const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;

  const currentEntities = filteredEntries?.slice(
    indexOfFirstEntity,
    indexOfLastEntity
  );

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleDropdownChange = (e) => {
    setEntitiesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const generatePageNumbers = () => {
    const maxPagesToShow = 5;
    const pages = [];
    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const getAllUsersData = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/v2/getAllUsersData`);
      if (res.data.status) {
        const transactions = res.data.history;
        setUsersList(transactions);
      } else {
        console.error("Error fetching transactions:", res.data.msg);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    getAllUsersData();
  }, [])

  const formatDate = (isoString) => {
    return new Date(isoString).toLocaleString();
  };

  return (
    <div className='bg-[#111111]'>
      <div>
        <div className="flex justify-between items-center mt-5 lg:mt-0 px-5">
          <div
            className={`bg-[#D9D9D9]/10 border rounded-full flex items-center`}
          >
            <input
              className="bg-transparent rounded-md py-1 px-3 outline-none w-[100%]"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FontAwesomeIcon icon={faMagnifyingGlass} className="px-3" />
          </div>
          <p className="text-end text-xs px-3 text-white">
            Show no of entity
            <select
              className="ml-2 outline-none rounded-md bg-transparent border-[1px]"
              onChange={handleDropdownChange}
              value={entitiesPerPage}
            >
              <option className="text-black" value="7">
                7
              </option>
              <option className="text-black" value="10">
                10
              </option>
            </select>
          </p>
        </div>
        <div className=" w-full overflow-hidden overflow-x-auto px-5 py-5">
          <table className=" w-full overflow-hidden overflow-x-auto text-sm 2xl:text-base  rounded-t-xl">
            <thead
              className={` bg-[#1d1d1c] 2xl:text-lg `}
            >
              <tr>
                <th className="py-5 px-5 md:px-10 font-Montserrat text-white whitespace-nowrap text-center ">
                  App ID
                </th>
                <th className="py-5 px-5 md:px-2 font-Montserrat text-white whitespace-nowrap text-center ">
                  User ID
                </th>
                <th className="py-5 px-5 md:px-2 font-Montserrat text-white whitespace-nowrap text-center">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="w-full text-sm rounded-lg px-3">
              {currentEntities.length === 0 ? (
                <tr>
                  <td colSpan="4" className="p-3 text-center text-white">
                    No Data found
                  </td>
                </tr>
              ) : (
                currentEntities.map((transaction, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? "bg-[#23221f]" : "bg-[#1d1d1c]"}`}
                  >
                    <td className="p-3 text-center text-white">{transaction.app_id}</td>
                    <td className="p-3 text-center text-white">{transaction.user_id}</td>
                    <td className="p-3 text-center text-white">{formatDate(transaction.created_at)}</td>
                  </tr>
                )))}
            </tbody>
          </table>
        </div>
        <div className="mb-3 flex justify-end gap-1 text-xs px-10 mt-5">
          <button
            className={`px-2 py-1 rounded-lg ${currentPage === 1
              ? "bg-white/10 cursor-not-allowed"
              : ""
              }`}
            onClick={handlePrevClick}
            disabled={currentPage === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="flex gap-1">
            {generatePageNumbers().map((page) => (
              <button
                key={page}
                className={`px-3 py-1 rounded-lg ${page === currentPage
                  ? "bg-white/30 text-white"
                  : "bg-white/10"
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}
          </div>
          <button
            className={`px-2 py-1 rounded-lg ${currentPage === totalPages
              ? "bg-white/10 cursor-not-allowed"
              : ""
              }`}
            onClick={handleNextClick}
            disabled={currentPage === totalPages}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </div>
  )
}
